import { UUID } from '@macs-frontend/core/utils/uuid';
import { ActionTeam } from './action-team';
import { ExternalUser } from './external-user';
import { Ratesheet } from './ratesheet.model';
import { Supplier } from './supplier';
import { TeamCost } from '@macs-frontend/features/company-management/team-cost/team-cost.types';

export interface MdTransport {
  uuid: UUID;
  actionTeam: ActionTeam;
  teamCost: TeamCost;
  qty: number;
  // float
  distance: number;
  ratesheet: Ratesheet;
  name: string;
  distanceUnitPrice: number;
  distanceBillablePrice: number;
  totalUnitPrice: number;
  totalBillablePrice: number;
  totalDistanceUnitPrice: number;
  costUnitPrice: number;
  costBillablePrice: number;
  totalDistanceBillablePrice: number;
  code: string;
  totalCostUnitPrice: number;
  totalCostBillablePrice: number;
  dictionaryTransport: null;
  handlingUnitPrice: number;
  handlingBillablePrice: number;
  status?: TransportStatuses;
  invoiceNo?: string;
  remark?: string;
  kmAfter?: number;
  kmBefore?: number;
  distanceTravelled?: number;
  licensePlate?: string;
  owner?: Supplier;
  driver?: ExternalUser;
}

export enum MdTransportStatuses {
  NoLocation = 'NO_LOCATION',
  NoDate = 'NO_DATE',
  Open = 'OPEN',
  InProgress = 'IN_PROGRESS',
  Ok = 'OK',
  Canceled = 'CANCELED',
  CanceledBy = 'CANCELED_BY',
}

export enum TransportStatuses {
  NOT_LOADED_BEFORE_ACTION = 'NLBA',
  LOADED_BEFORE_ACTION = 'LBA',
  NOT_LOADED_AFTER_ACTION = 'NLAA',
  LOADED_AFTER_ACTION = 'LAA',
}

export interface TransportFilterItem {
  uuid: UUID;
  label: string;
}
